import React from "react";
import { Link } from "react-router-dom";
const Breadcrumbs = ({ cat, page }) => {
  return (
    <div className="flex items-center flex-wrap justify-center gap-x-2 text-font mb-3 text-2xl capitalize">
      <Link to={"/"} className="hover:underline">
        Home
      </Link>
      <span>|</span>
      <p>{cat} </p>
      <span>|</span>
      <p>{page}</p>
    </div>
  );
};

export default Breadcrumbs;
